// extracted by mini-css-extract-plugin
export default {"container":"hawk-price-note-container"};